import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const NotificationsMenuButtonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotificationsMenuButton"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"marketingOptIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"optedIn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"messagesDismissed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"NotificationsMenuButton","document":NotificationsMenuButtonDocument}} as const;
export type NotificationsMenuButtonQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type NotificationsMenuButtonQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'confirmed' | 'id'>
    & { marketingOptIn?: Types.Maybe<(
      { __typename: 'Member_MarketingOptIn' }
      & Pick<Types.Member_MarketingOptIn, 'date' | 'optedIn'>
    )>, messagesDismissed?: Types.Maybe<Array<(
      { __typename: 'Member_MessageDismissed' }
      & Pick<Types.Member_MessageDismissed, 'name'>
    )>> }
  )> }
);




/**
 * __useNotificationsMenuButtonQuery__
 *
 * To run a query within a React component, call `useNotificationsMenuButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsMenuButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsMenuButtonQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useNotificationsMenuButtonQuery(baseOptions: Apollo.QueryHookOptions<NotificationsMenuButtonQuery, NotificationsMenuButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsMenuButtonQuery, NotificationsMenuButtonQueryVariables>(NotificationsMenuButtonDocument, options);
      }
export function useNotificationsMenuButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsMenuButtonQuery, NotificationsMenuButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsMenuButtonQuery, NotificationsMenuButtonQueryVariables>(NotificationsMenuButtonDocument, options);
        }
export type NotificationsMenuButtonQueryHookResult = ReturnType<typeof useNotificationsMenuButtonQuery>;
export type NotificationsMenuButtonLazyQueryHookResult = ReturnType<typeof useNotificationsMenuButtonLazyQuery>;
export type NotificationsMenuButtonQueryResult = Apollo.QueryResult<NotificationsMenuButtonQuery, NotificationsMenuButtonQueryVariables>;